import { TypeOf } from "io-ts";
import React from "react";

import { Location } from "../../models";

import styles from "./LocationListItem.module.scss";

interface Props {
    location: TypeOf<typeof Location>;
}

export const Address = ({
    location: { line1, line2, line3, city, state, postcode, country },
}: Props) => {
    // Adapt format of line4 based on country
    let line4 = `${city}, ${state} ${postcode}`; // Default: US format
    if (country === "MX") {
        line4 = `${postcode} ${city}, ${state}`; // Mexico format
    }

    return (
        <address className={styles.text}>
            {line1}
            {line2 && (
                <>
                    <br />
                    {line2}
                </>
            )}
            {line3 && (
                <>
                    <br />
                    {line3}
                </>
            )}
            {line4 && `, ${line4}`}
        </address>
    );
};
